import type { LucideIcon } from 'lucide-react'
import type { CSSProperties } from 'react'
import { getT10TextStyleForName } from '@/lib/tableau10'
import { BarChart3, CheckCircle2, FileText, GitMerge, Package, Search, Sparkles, UserPlus } from 'lucide-react'

interface SourceConfig {
  label: string
  detailLabel: string
  icon: LucideIcon
  className?: string
  style?: CSSProperties
}

export const INBOX_SOURCES: Record<string, SourceConfig> = {
  COMPANY_EVENT: { label: 'Events', detailLabel: 'Company Event', icon: Sparkles, style: getT10TextStyleForName('orange') },
  ASSIGNMENT: { label: 'Assigned', detailLabel: 'Account Assignment', icon: UserPlus, style: getT10TextStyleForName('green') },
  ENRICHMENT_COMPLETE: { label: 'Enrichment', detailLabel: 'Enrichment Complete', icon: CheckCircle2, style: getT10TextStyleForName('blue') },
  SCOUT_LEADS_READY: { label: 'Scout', detailLabel: 'Scout Leads Ready', icon: Search, style: getT10TextStyleForName('purple') },
  TAM_REPORT_READY: { label: 'Market Intelligence', detailLabel: 'Market Intelligence Report Ready', icon: BarChart3, style: getT10TextStyleForName('teal') },
  RENEWAL_REPORT_READY: { label: 'Platform Report', detailLabel: 'Platform Report Ready', icon: FileText, style: getT10TextStyleForName('brown') },
  CRM_CLEANUP: { label: 'CRM Cleanup', detailLabel: 'CRM Cleanup Required', icon: GitMerge, style: getT10TextStyleForName('pink') },
  ORDER_RECEIVED: { label: 'Order', detailLabel: 'New Order Parsed', icon: Package, style: getT10TextStyleForName('yellow') },
}

export const VALID_SOURCES = Object.keys(INBOX_SOURCES)

export const BATCH_COMPLETE_SOURCES = new Set(['ENRICHMENT_COMPLETE', 'SCOUT_LEADS_READY', 'CRM_CLEANUP'])

export const ACCOUNT_LESS_SOURCES = new Set(['TAM_REPORT_READY', 'RENEWAL_REPORT_READY'])

export function getSourceConfig(source: string): SourceConfig {
  return INBOX_SOURCES[source] ?? { label: source, detailLabel: source, icon: Sparkles, className: 'text-muted-foreground' }
}
